import ClientLogger from './clientLogger';

function loadLingua(locale) {
    return new Promise(function(resolve) {
        require.ensure([], function(require) {
            resolve(require(`../lingua/compiled/${locale}`));
        }, function(error) {
            ClientLogger.logError(`Unexpected error while trying to load lingua keys error=${error}`);
        }, 'lex-msgs');
    });
}

module.exports = {
    loadLingua
};
